export default __webpack_public_path__ + "static/truck_yellow_house-c19c9d0c40cbcc9b6547548dc1cd0bb3.jpg";